// -----------------------------------------------------------------------------
//   API Configuration
// -----------------------------------------------------------------------------

/**
 * Centralized API server URL configuration.
 * REACT_APP_API_URL overrides defaults in dev (e.g. Playwright) and in production builds
 * (e.g. Capacitor / staging).
 */
const productionURL = "https://web-production-a537.up.railway.app";
const defaultDevURL = "http://localhost:5000";

function normalizeApiUrl(url: string): string {
    return url.replace(/\/$/, "");
}

function fromEnvOrFallback(fallback: string): string {
    const fromEnv = process.env.REACT_APP_API_URL?.trim();
    if (fromEnv) return normalizeApiUrl(fromEnv);
    return fallback;
}

function devServerURL(): string {
    return fromEnvOrFallback(normalizeApiUrl(defaultDevURL));
}

export const serverURL =
    process.env.NODE_ENV === "production"
        ? fromEnvOrFallback(normalizeApiUrl(productionURL))
        : devServerURL();
